import {
  ContractType,
  Country,
  PropertySpaceOption,
  PropertySpaceRange,
} from '@immosky/types';

interface PropertySpaceOptions {
  buy: PropertySpaceOption[];
  rent: PropertySpaceOption[];
}

export const INITIAL_PROPERTY_SPACE_RANGE: PropertySpaceRange = {
  min: {
    text: '',
    value: 0,
  },
  max: {
    text: '',
    value: 0,
  },
};

const countrySpecificPropertySpaceOptions: {
  [country: string]: PropertySpaceOptions;
} = {
  ['CH']: {
    buy: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '300',
        value: 300,
      },
      {
        text: '400',
        value: 400,
      },
      {
        text: '500',
        value: 500,
      },
      {
        text: '600',
        value: 600,
      },
      {
        text: '700',
        value: 700,
      },
      {
        text: '800',
        value: 800,
      },
      {
        text: '900',
        value: 900,
      },
      {
        text: `1'000`,
        value: 1000,
      },
      {
        text: `1'100`,
        value: 1100,
      },
      {
        text: `1'200`,
        value: 1200,
      },
      {
        text: `1'300`,
        value: 1300,
      },
      {
        text: `1'400`,
        value: 1400,
      },
      {
        text: `1'500`,
        value: 1500,
      },
      {
        text: `1'600`,
        value: 1600,
      },
      {
        text: `1'700`,
        value: 1700,
      },
      {
        text: `1'800`,
        value: 1800,
      },
      {
        text: `1'900`,
        value: 1900,
      },
      {
        text: `2'000+`,
        value: Infinity,
      },
    ],
    rent: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '300',
        value: 300,
      },
      {
        text: '400',
        value: 400,
      },
      {
        text: '500+',
        value: Infinity,
      },
    ],
  },
  ['FR']: {
    buy: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '300',
        value: 300,
      },
      {
        text: '400',
        value: 400,
      },
      {
        text: '500',
        value: 500,
      },
      {
        text: '600',
        value: 600,
      },
      {
        text: '700',
        value: 700,
      },
      {
        text: '800',
        value: 800,
      },
      {
        text: '900',
        value: 900,
      },
      {
        text: '1 000',
        value: 1000,
      },
      {
        text: `1 100`,
        value: 1100,
      },
      {
        text: `1 200`,
        value: 1200,
      },
      {
        text: `1 300`,
        value: 1300,
      },
      {
        text: `1 400`,
        value: 1400,
      },
      {
        text: `1 500`,
        value: 1500,
      },
      {
        text: `1 600`,
        value: 1600,
      },
      {
        text: `1 700`,
        value: 1700,
      },
      {
        text: `1 800`,
        value: 1800,
      },
      {
        text: `1 900`,
        value: 1900,
      },
      {
        text: `2 000`,
        value: 2000,
      },
      {
        text: `2 000+`,
        value: Infinity,
      },
    ],
    rent: [
      {
        text: '0',
        value: 0,
      },
      {
        text: '100',
        value: 100,
      },
      {
        text: '200',
        value: 200,
      },
      {
        text: '300',
        value: 300,
      },
      {
        text: '400',
        value: 400,
      },
      {
        text: '500+',
        value: Infinity,
      },
    ],
  },
};

export function getPropertySpaceOptionsForContractType(
  countries: Country[],
  contractType: ContractType
): PropertySpaceOption[] {
  let propertySpaceOptions = countrySpecificPropertySpaceOptions['CH'];

  if (countries.indexOf('FR') > -1) {
    propertySpaceOptions = countrySpecificPropertySpaceOptions['FR'];
  }

  switch (contractType) {
    case 'buy':
      return propertySpaceOptions.buy;
    case 'rent':
      return propertySpaceOptions.rent;
  }
}
